import { REDUX_MODEL_KEY } from '../../../../redux/constants/key'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import createPointerAddReduxUtil from '../../../../redux/actions/create/create-pointer'
import setUtil from '../../../../../utils/set'
import { getObjectUtil } from 'packages/src'

export default function createSingleAssociationAddReduxUtil (payload) {
  const {
    stateWrapper,
    association,
    existingInstance,
    isLocal,
    instance,
    dataPath,
    properties,
    associationKey
  } = payload

  let existingAssociation
  if (existingInstance && isNewReduxUtil(existingInstance)) {
    existingAssociation =
      (
        getObjectUtil(
          stateWrapper.state,
          `${getPathReduxUtil(existingInstance)}.${REDUX_MODEL_KEY.CHANGED}.${associationKey}`
        ) || getObjectUtil(
          stateWrapper.state,
          `${getPathReduxUtil(existingInstance)}.${REDUX_MODEL_KEY.DATA}.${associationKey}`
        )
      )
  }

  const referencePath = `${getPathReduxUtil(instance)}.${dataPath}`
  const pointer = createPointerAddReduxUtil(stateWrapper, {
    existingInstance: existingAssociation
      ? getObjectUtil(stateWrapper.state, getPathReduxUtil(existingAssociation))
      : null,
    referencePath,
    association,
    properties,
    isLocal
  })
  return setUtil(instance, dataPath, pointer)
}
